import { ReactElement } from "react";
import { Dialog } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import CustomLoading from "@/shared/components/customLoading/CustomLoading";

import {
  CloseButton,
  ContentContainer,
  FooterContainer,
  Panel,
} from "./immersive-styles";

type ImmersiveDialogAdapterProps = {
  isOpen: boolean;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  isLoading: boolean;
  onCloseCallback: () => void;
  panelWidth?: string;
};

export function ImmersiveDialogAdapter({
  isOpen,
  content,
  footer,
  isLoading,
  onCloseCallback,
  panelWidth,
}: ImmersiveDialogAdapterProps): ReactElement {
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={onCloseCallback}
        sx={{
          "& .MuiDialog-paper": {
            width: "auto",
            maxWidth: "none",
            margin: "16px",
            background: "transparent",
            boxShadow: "none",
            overflow: "visible",
          },
        }}
      >
        {isOpen && (
          <Panel $width={panelWidth}>
            <CloseButton onClick={onCloseCallback}>
              <CloseOutlinedIcon fontSize="large" />
            </CloseButton>
            <ContentContainer>{content}</ContentContainer>
            {footer ? <FooterContainer>{footer}</FooterContainer> : null}
          </Panel>
        )}
      </Dialog>
      <CustomLoading isOpen={isLoading} zIndex="snackbar" />
    </>
  );
}
